import * as z from "zod";
import { automationSummarySchema } from "./common";

/** Turns a published automation on or off. */
export const setActive = {
  name: "setActive" as const,
  input: z.object({ id: z.string(), active: z.boolean() }),
  output: z.object({ automation: automationSummarySchema }),
};
